import {html, HTMLTemplateResult} from "lit";
import {when} from "lit/directives/when.js";
import {NavigationItem} from "./navigation-item.interface";
import {property} from "lit/decorators/property.js";
import {customElement} from "lit/decorators/custom-element.js";
import {navigationItemStyles} from "./navigation-item.styles";
import {AbstractLitElement} from "../abstract-lit.element";

@customElement(`ha-navigation-item`)
export class HaNavigationItemComponent extends AbstractLitElement {

    static styles = navigationItemStyles;

    @property({type: Object})
    public item: NavigationItem | null = null;

    @property({type: Boolean, attribute: `collapsed`})
    public isCollapsed = false;

    public render(): HTMLTemplateResult | string {
        if (!this.item) {
            return ``;
        }

        const item = this.item!;
        return html`
                <div class="ha-app__navigation-item__prefix" title=${item.label}>
                    ${item.prefix}
                </div>
                <div class="ha-app__navigation-item__label">
                    ${item.label}
                </div>
                ${when(item.postfix, () => html`
                    <div class="ha-app__navigation-item__postfix">
                        ${item.postfix}
                    </div>
                `)}
        `;
    }
}